import React from 'react';

export const Ban = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--ban';
  color = color || '#0076CC';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M16.364 16.364C19.8787 12.8492 19.8787 7.15076 16.364 3.63604C12.8492 0.12132 7.15076 0.12132 3.63604 3.63604M16.364 16.364C12.8492 19.8787 7.15076 19.8787 3.63604 16.364C0.12132 12.8492 0.12132 7.15076 3.63604 3.63604M16.364 16.364L3.63604 3.63604"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Ban;
